<app-tag-filter></app-tag-filter>
<p-divider></p-divider>
<div *ngIf="tagStore.filteredSortedByName() as tags">
  <p-pickList
    #listPickerCtrl
    [source]="tags"
    [target]="selected"
    sourceHeader="Schlagworte"
    targetHeader="Auswahl"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="showSourceControls"
    [showTargetControls]="showTargetControls"
    (onMoveToSource)="updateSelection()"
    (onMoveToTarget)="updateSelection()"
    (onMoveAllToTarget)="updateSelection()"
    (onMoveAllToSource)="updateSelection()"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
    breakpoint="1400px">
    <ng-template let-tag pTemplate="item">
      <div class="flex-1 flex flex-column gap-2">
        <div class="flex align-items-center gap-2 text-lg">
          <i class="fas fa-tag"></i>
          <span>
            {{ tag.title }}
          </span>
        </div>
      </div>
    </ng-template>
  </p-pickList>
</div>
